module.exports = __webpack_public_path__ + "img/notifiche-alertmsg.fbaf5ca7.png";